import {getMediaAssetProps} from '~/cms/helpers/getMediaAssetProps'

import {WYSIWYGMultiLineStructuredText} from '~/cms/components/WYSIWYG/_components/WYSIWYGMultiLineStructuredText'
import {wysiwygComponentVariants} from '~/cms/components/WYSIWYG/_utils/variants'
import {type HgWYSIWYGType} from '~/design-system/hg/components/HgWYSIWYG'
import {
  type HgArticleWYSIWYGMediaAssetProps,
  HgArticleWYSIWYGSplitAssetAndBody,
} from '~/design-system/hg/components/HgWYSIWYG/Article/_components'
import {type ArticleSplitAssetAndBodyFragment} from './_generated/fragment.graphql'

type DatoWYSIWYGSplitAssetAndBodyProps = ArticleSplitAssetAndBodyFragment & {
  openLightbox: NonNullable<HgArticleWYSIWYGMediaAssetProps['openLightbox']>
  wysiwygType: HgWYSIWYGType
}

export const DatoWYSIWYGSplitAssetAndBody = ({
  asset,
  bodyContent,
  openLightbox,
  wysiwygType,
}: DatoWYSIWYGSplitAssetAndBodyProps) => {
  const {splitAssetAsset, splitAssetComponent} = wysiwygComponentVariants()
  return (
    <HgArticleWYSIWYGSplitAssetAndBody
      assetProps={{
        ...getMediaAssetProps(asset),
        openLightbox,
      }}
      body={
        <WYSIWYGMultiLineStructuredText
          data={bodyContent}
          wysiwygType={wysiwygType}
        />
      }
      classNames={{wrapper: splitAssetComponent(), asset: splitAssetAsset()}}
    />
  )
}
